<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Session Logs</span>
        </div>
    </div>
    <div class="card card_content">

        <form [formGroup]="searchform">

            <div class="row d-flex justify-content-center flex-wrap grid-margin">

                <div class="mb-3">
                    <app-button (refreshClicked)="refresh()"></app-button>
                    <button type="button" class="btn excel_btn mr-3" (click)="exportData()">
                        <i class="fa fa-file-excel mr-1"></i> Export
                    </button>
                </div>

                <div class="col-md-4 padd-right-file" style="display: flex; justify-content: center;">

                    <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
                        style="margin-bottom: 1rem !important;">
                        <mat-label>Search</mat-label>
                        <div class="search-input-container">
                            <input placeholder="Enter User Name" id="search" matInput
                                formControlName="SearchQuery" type="text" #searchInput
                                (keydown.space)="preventLeadingSpace($event)" (keydown.enter)="search()">
                        </div>
                    </mat-form-field>
                    <button type="button" matSuffix mat-icon-button aria-label="Search"
                        class="badge bg-light-blue image-button" (click)="search()">
                        <mat-icon style="color: white;">search</mat-icon>
                    </button>

                </div>
            </div>
        </form>


        <div class="table-responsive mt-2 mb-4">
            <mat-table #table [dataSource]="dataSource">

                <ng-container matColumnDef="Username">
                    <mat-header-cell *matHeaderCellDef>Username</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign"> {{dataField.username}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="IP">
                    <mat-header-cell *matHeaderCellDef>IP</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.framedipaddress}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Caller">
                    <mat-header-cell *matHeaderCellDef> Caller</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.callingstationid}} </p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="NAS">
                    <mat-header-cell *matHeaderCellDef>NAS</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.nasipaddress}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Start">
                    <mat-header-cell *matHeaderCellDef>Start</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.acctstarttime | date:'dd-MM-yyyy HH:mm:ss'}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Stop">
                    <mat-header-cell *matHeaderCellDef>Stop</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{dataField.acctstoptime | date:'dd-MM-yyyy HH:mm:ss'}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Download">
                    <mat-header-cell *matHeaderCellDef>Download</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{formatBytes(dataField.acctoutputoctets)}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Upload">
                    <mat-header-cell *matHeaderCellDef>Upload</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">{{formatBytes(dataField.acctinputoctets)}}</p>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
        </div>
        <div *ngIf="dataSource.filteredData.length === 0" class="no-data-message">
            <p>No data found</p>
        </div>

        <div class="table_pagenation">
            <mat-paginator #paginator [length]="totalCount" [pageIndex]="pageNumber - 1" *ngIf="totalCount > 50"
                [pageSize]="pageSize" [pageSizeOptions]="[50, 100]" (page)="onPageChange($event)">
            </mat-paginator>
        </div>
    </div>
</div>